export default __webpack_public_path__ + "static/icon-phone-8251751e32135845b7816b58800b7660.png";